import { Link } from "basis";

interface Props {
  onClick: () => void;
}

export const CancelLink = ({ onClick: handleOnClick }: Props) => {
  const onClick = (e) => {
    e.preventDefault();
    handleOnClick();
  };

  return (
    <Link href="#" newTab={false} onClick={onClick}>
      Cancel
    </Link>
  );
};
